var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAffiliations)?_c('div',[_c('AthleteSectionSubheading',[_vm._v("Teams")]),_c('div',{staticClass:"grid gap-6 mb-8 lg:grid-cols-3"},_vm._l((_vm.shownAffiliations),function(affiliation,index){return _c('AthleteTeamCard',{key:index,staticClass:"w-full",attrs:{"affiliation":affiliation,"showLinks":_vm.showLinks}})}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }